export const Images = {
  shape: require('./image_shape.png'),
  avatar: require('./image_avatar.png'),
  image_login_background: require('./image_login_background.png'),
  image_no_visitors: require('./image_no_visitors.png'),
  image_no_requests: require('./image_no_requests.png'),
  image_document_empty: require('./image_document_empty.png'),
  circle: require('./image_circle.png'),
};
